import ApiService from "@/common/api.service";
import AgentService from "@/common/agent.service";

const state = {
  //list: [], //lista dei gateway che rispondono correttamente
  full: [], //lista completa con le proprietà, raggiungbile o meno
  //searching: [], //lista
  loading: false,
  current: null,
  progress: null
};
const gwsall = [
  "gw-t2420001",
  "gw-t2420002",
  "gw-u1360001",
  "gw-u1360002",
  "gw-u2320001",
  "gw-u2320002",
  "gw-u3010001",
  "gw-u3010002",
  "gw-u3010003",
  "gw-u3010004",
  "gw-u3010005",
  "gw-u3010006",
  "gw-u3010007",
  "gw-u3010008",
  "gw-u3010009",
  "gw-u3010010",
  "gw-u3010011",
  "gw-u4930001",
  "gw-u4930002",
  "gw-u4930003",
  "gw-u4930004",
  "gw-u4930005",
  "gw-u4930006",
  "gw-u4930007",
  "gw-u4930008",
  "gw-u4930009",
  "gw-u4930010",
  "gw-u4930011",
  "gw-u4930012",
  "gw-u4930013",
  "gw-u4930014",
  "gw-u4930015",
  "gw-u4930016",
  "gw-u4930017",
  "gw-u4930018",
  "gw-u4930019",
  "gw-u4930020",
  "gw-u4930021",
  "gw-u4930022",
  "gw-u4930023",
  "gw-u4930024",
  "gw-u4930025",
  "gw-u4930026",
  "gw-u4930027",
  "gw-u4930028",
  "gw-u4930029",
  "gw-u4930030",
  "gw-u4930031",
  "gw-u4930032",
  "gw-u4930033",
  "gw-u4930034",
  "gw-u4930035",
  "gw-u4930036",
  "gw-u4930037",
  "gw-u4930038",
  "gw-u4930039",
  "gw-v2010001",
  "gw-v2010002",
  "gw-v2010003",
  "gw-v2010004",
  "gw-v2010005",
  "gw-v2010006",
  "gw-v2010007",
  "gw-v2010008",
  "gw-v2010009",
  "gw-v2010010",
  "gw-v2010011",
  "gw-v2010012",
  "gw-v2010013",
  "gw-v2010014",
  "gw-v2010015",
  "gw-v2010016",
  "gw-v2010017",
  "gw-v2010018",
  "gw-v2010019",
  "gw-v2010020",
  "gw-v2010021",
  "gw-v2120001",
  "gw-v2120002",
  "gw-v2120003",
  "gw-v2120004",
  "gw-v2120005",
  "gw-v2120006",
  "gw-v2120007",
  "gw-v2120008",
  "gw-v2120009",
  "gw-v2120010",
  "gw-v2120011",
  "gw-v2120012",
  "gw-v2120013",
  "gw-v2120014",
  "gw-v2120015",
  "gw-v2120016",
  "gw-v2120017",
  "gw-v2120018",
  "gw-v2120019",
  "gw-v2120020",
  "gw-v2120021",
  "gw-v2120022",
  "gw-v2120023",
  "gw-v2120024",
  "gw-v2120025",
  "gw-v2120026",
  "gw-v2120027",
  "gw-v2120028",
  "gw-v2120029",
  "gw-v2120030",
  "gw-v2120031",  
];

const actions = {
  //scansione con la nuova tecnica delle matricole note
  async scanV2(context) {
    if (context.state.progress !== null) {
      console.log('Full advanced scan in progress. Please wait or refresh page');
      return;
    }
    console.log('Scan V2 started')
    context.commit("progress", 0);
    //context.commit("flush");

    var count = 0;
    for (const gw of gwsall) {
      console.log('Started testing for gw', gw);
      try {
          
        await ApiService.testAgent(gw, 2500);
        console.log('Completed with success for gw', gw);
        //fullV2 non verifica interface in modo da non avere duplicati dai due tipi di scansione
        //await context.dispatch("addFullV2", {
        await context.dispatch("addFull", {
          id: gw.substring(3).toUpperCase(),
          interface: "any",
          local: gw,
          help: 'Experimental scan result',
          status: 'online'
        });
      } catch {
        console.log('Completed with fail for gw', gw);
      }
      
      count += 1;
      context.commit("progress", Math.floor(count*100/gwsall.length));

      // ApiService.testAgent(gw, 2000).then(() => {
      //   console.log('Completed with success for gw', gw);
      //   context.dispatch("addFull", {
      //     id: gw,
      //     interface: "any",
      //     local: gw,
      //     help: 'Experimental scan result',
      //     status: 'online'
      //   }).then(() => {
      //     context.commit("progress", this.progress + 1);
      //   });

      // }).catch(() => {
      //   console.log('Completed with fail for gw', gw);
      //   context.commit("progress", this.progress + 1);
      // })
    }
    context.commit("progress", null);

  },
  async scan(context) {
    context.commit("loading", true);
    //context.commit("flush");
    if (location.host != "find.farfisa.com" 
    //&& !location.host.startsWith('localhost')
    ) {
      console.log("Current host: " + location.host);
      await context.dispatch("addFull", {
        id: "LOCAL",
        interface: "UNKNOWN",
        local: location.host,
        help: 'help.info_about_local',
        status: 'none'
      });
    }
    // await context.dispatch("addFull", {
    //   id: "V2010020",
    //   interface: "any",
    //   local: 'gw-v2010020',
    //   help: 'Experimental search',
    //   status: 'hidden'
    // });

    const gws = await ApiService.findAgents();

    console.log("Current Gateways: ", gws);
    for (const gw of gws) {
      await context.dispatch("addFull", {...gw, ...{status: 'none'}});
      //await context.dispatch('test', gw);
      //console.log('Test for gw ' + gw.id + ' completed');
    }


    // for (const gw of gwsall) {
    //   await context.dispatch("addFull", {
    //     id: gw,
    //     interface: "any",
    //     local: gw,
    //     help: 'Experimental search',
    //     status: 'hidden'
    //   });
    // }



    //faccio il test di tutti, anche quelli che non mi ha restituito la chiamata
    for (const gw of context.state.full) {
      await context.dispatch("test", gw);
      console.log("Test for gw " + gw.id + " completed");
    }
    context.commit("loading", false);
  },
  test(context, gw) {
    return new Promise((resolve, reject) => {
      if (gw.status != 'hidden')
        context.commit("setTesting", gw);
      ApiService.testAgent(gw.local)
        .then(result => {
          context.commit("setOnline", gw);
          resolve(result);
        })
        .catch(error => {
          console.log("Error testing gateway ", gw, error);
          if (gw.status != 'hidden')
            context.commit("setOffline", gw);
          resolve(error);
        });
    });
  },
  setCurrent(context, gw) {
    console.log("Going to committing setCurrent", gw);
    context.commit("setCurrent", gw);
  },
  blink(context, gw) {
    return ApiService.blinkAgent(gw.local);
  },
  addFull(context, agent) {
    let found = null;
    state.full.forEach(gw => {
      if (gw.id == agent.id && gw.interface == agent.interface) {
        //aggiorno l'indirizzo se cambiato
        gw.local = agent.local;
        found = gw;
      }
    });
    if (!found) context.commit("addFull", agent);
    return found;
  },
  addFullV2(context, agent) {
    let found = null;
    state.full.forEach(gw => {
      if (gw.id == agent.id) {
        //se l'ho trovato vuol dire che funziona correttamente il classico sistema
        found = gw;
      }
    });
    if (!found) context.commit("addFull", agent);
    return found;
  }
};

const mutations = {
  /*
  //aggiunge un gateway all'elenco dei gateway da ricercare
  addSearching(state, agent) {
    state.searching.push(agent);
    console.log("Added " + agent);
  },
  //rimuove un gateway dall'elenco dei gateway da ricercare
  removeSearching(state, agent) {
    console.log("Removing " + agent);
    let index = state.searching.indexOf(agent);
    if (index > -1) {
      state.searching.splice(index, 1);
      console.log("Removed " + agent + " with index " + index);
    }
  },*/
  addFull(state, agent, status) {
    //state.full.push({ ...agent, ...{ status: status } });
    state.full.push(agent);
  },
  /*
  add(state, agent) {
    state.list.push(agent);
  },*/
  setTesting(state, agent) {
    let object = state.full.filter(obj => {
      //return obj.id === agent.id;
      return obj.interface === agent.interface;
    })[0];
    if (object) {
      //se lo stato è online non vado a visualizzare la progressbar che indica che sono in fase di testing
      //se lo stato precedente era online, voglio solo verificare, quindi solo se il test fallisce allora visualizzarò offline
      if (object.status != "online") {
        object.status = "testing";
      }
    }
  },
  setOnline(state, agent) {
    let object = state.full.filter(obj => {
      //return obj.id === agent.id;
      return obj.interface === agent.interface;
    })[0];
    if (object) {
      object.status = "online";
    }
  },
  setOffline(state, agent) {
    let object = state.full.filter(obj => {
      //return obj.id === agent.id;
      return obj.interface === agent.interface;
    })[0];
    if (object) {
      object.status = "offline";
    }
  },
  loading(state, value) {
    state.loading = value;
  },
  progress(state, value) {
    state.progress = value;
  },
  flush(state) {
    //state.list = [];
    state.full = [];
    //state.searching = [];
  },
  setCurrent(state, gw) {
    state.current = gw;
    console.log("Going to set current gateway: ", gw);
    //salvo il current agent sul local storage
    AgentService.saveAgent(gw);
    //imposto l'indirizzo ip scelto come base per le richieste axios
    if (gw) ApiService.setAgent();
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
